import * as Sentry from '@sentry/react';

const DEFAULT_QUEUE_LIMIT = 6;

class LimitQueue {
    limit: number;
    items: string[];
    currentIndex: number;

    constructor(limit = DEFAULT_QUEUE_LIMIT) {
        this.limit = limit;
        this.items = [];
        this.currentIndex = 0;
    }

    addItem(item: string) {
        this.items.unshift(item);
        this.items = this.items.slice(0, this.limit);
    }

    getItems() {
        return this.items;
    }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const pushRequestIdToSentry = (sentryEnabled: boolean, limit: number) => {
    const sentryRequestQueue = new LimitQueue(limit);
    return (requestId: string): void => {
        if (sentryEnabled && requestId) {
            // Из-за дублирования заголовка x-request-id в качестве requestId
            // может прийти строка из нескольких идентификаторов разделённых ','
            // В Sentry отправляем только уникальные requestId
            const requestIdArray = requestId.split(',').map((item) => item.trim());
            const uniqueRequestId = [...new Set(requestIdArray)].join(', ');

            sentryRequestQueue.addItem(uniqueRequestId);

            Sentry.getCurrentScope().setExtra('lastAsyncRequestIds', sentryRequestQueue.getItems());
        }
    };
};

export default pushRequestIdToSentry;
